import { Directive, HostListener } from '@angular/core'

@Directive({
  selector: '[appResetInputScroll]',
  standalone: false,
})
export class ResetInputScrollDirective {
  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent): void {
    const input = event.target as HTMLInputElement
    input.scrollLeft = 0
  }
}
